"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var forms_component_1 = require("./component/forms/forms.component");
var appRoutes = [
    {
        path: '',
        component: forms_component_1.FormsComponent,
    },
    {
        path: "form-builder",
        loadChildren: function() { return new Promise(function (resolve, reject) {  require.ensure([], function (require) {    resolve(require('@synisys/idm-dynamic-layout-designer')['FormBuilderModule']);  }, function(e) {    reject({ loadChunkError: true, details: e });  });}) }
    }
];
exports.formManagementRouting = router_1.RouterModule.forChild(appRoutes);
//# sourceMappingURL=form-management.routing.js.map